import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';

import CmsAnimationSettings from './CmsAnimationSettings';
import CmsParallaxSettings from './CmsParallaxSettings';

class CmsEffectsSettings extends React.Component {
  setEffectType = effectType => {
    const { setParam } = this.props;

    setParam('effectType', effectType);
  };

  resetEffectType = e => {
    e.preventDefault();
    e.stopPropagation();

    const { setParams } = this.props;

    setParams([
      { name: 'effectType', value: 'none' },
      { name: 'animationType', value: 'none' },
      { name: 'parallaxType', value: 'none' },
    ]);
  };

  render() {
    const {
      intl: { messages },
      getParamValue,
    } = this.props;

    let effectType = getParamValue('effectType', 'none');
    const currentAnimationType = getParamValue('animationType', 'none');
    const currentParallaxType = getParamValue('parallaxType', 'none');

    if (currentAnimationType !== 'none') {
      effectType = 'animation';
    } else if (currentParallaxType !== 'none') {
      effectType = 'parallax';
    }

    return (
      <>
        <Row className="p-b-20">
          {effectType === 'none' ? (
            <>
              <Col xs={4} class="p-r-5 p-l-5">
                {/* none */}
                <Button
                  block
                  onClick={() => this.setEffectType('none')}
                  bsStyle={effectType === 'none' ? 'primary' : undefined}
                >
                  {messages.none}
                  <br />
                  <i class="far fa-ban" />
                </Button>
              </Col>
              <Col xs={4} class="p-r-5 p-l-5">
                {/* fade */}
                <Button
                  block
                  onClick={() => this.setEffectType('animation')}
                  bsStyle={effectType === 'animation' ? 'primary' : undefined}
                >
                  {messages.animation}
                  <br />
                  <i class="fal fa-film" />
                </Button>
              </Col>
              <Col xs={4} class="p-r-5 p-l-5">
                {/* slide */}
                <Button
                  block
                  onClick={() => this.setEffectType('parallax')}
                  bsStyle={effectType === 'parallax' ? 'primary' : undefined}
                >
                  {messages.parallax}
                  <br />
                  <i class="fal fa-mouse-alt" />
                </Button>
              </Col>
            </>
          ) : (
            <>
              <a
                href="#resetEffects"
                className="m-r-15 bg-master-light fs-14 p-l-15 p-r-15 p-t-5 p-b-5 text-master b-rad-lg"
                onClick={this.resetEffectType}
              >
                <i className="fa fa-angle-left m-r-5" /> {messages.back}
              </a>

              {effectType === 'animation' && messages.animation}
              {effectType === 'parallax' && messages.parallax}
            </>
          )}
        </Row>

        {effectType === 'animation' && <CmsAnimationSettings {...this.props} />}
        {effectType === 'parallax' && <CmsParallaxSettings {...this.props} />}
      </>
    );
  }
}

export default CmsEffectsSettings;
